import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {RoutingTrackerService} from '../../../Services/routing-tracker.service';

@Component({
  selector: 'app-not-authorized-page',
  templateUrl: './not-authorized-page.component.html',
  styleUrls: ['./not-authorized-page.component.css'],
  standalone: false
})
export class NotAuthorizedPageComponent implements OnInit, AfterViewInit {

  hasPrevRoute = false;

  constructor(
    private routeTracker: RoutingTrackerService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    const prev = this.routeTracker.getPreviousUrl();
    this.hasPrevRoute = !!(prev && prev.length > 0);
  }

  ngAfterViewInit() {
  }

  back(): void {
    const prevPage = this.routeTracker.getPreviousUrl();
    if (prevPage && prevPage.length > 0) {
      this.router.navigateByUrl(prevPage).then();
      return;
    }
    try {
      window.close();
    } catch {
      // ignore
    } finally {
      this.router.navigate(['/home']).then();
    }
  }

  close(): void {
    try {
      window.close();
    } catch {
      // ignore
    } finally {
      this.router.navigate(['/home']).then();
    }
  }
}
